import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlareAvatarComponent } from './flare-avatar.component';

@NgModule({
  imports: [
    CommonModule,
    MatTooltipModule
  ],
  declarations: [
    FlareAvatarComponent
  ],
  exports: [
    FlareAvatarComponent
  ]
})
export class FlareAvatarModule { }
